import { createContext, useContext } from 'react';

import type { BelepettFelhasznalo } from './api.ts';

/**
 * A belépett felhasználó és a jogai. (3.0 / 1.)
 *
 * A felület ebből dönti el, mit mutat meg. **A tényleges tiltás a szerveren
 * van** — ez csak azért kell, hogy ne is lássa, amihez úgysem nyúlhat.
 */
export const FelhasznaloContext = createContext<BelepettFelhasznalo | null>(null);

export function useFelhasznalo(): BelepettFelhasznalo | null {
  return useContext(FelhasznaloContext);
}

/** A négy szint: 0 nem látja · 1 látja · 2 új felvétel · 3 módosíthat. */
export function useJog(kulcs: string): number {
  const f = useFelhasznalo();
  return f?.jogok[kulcs] ?? 0;
}

/** Megnyithatja-e a képernyőt. */
export function useLathat(kulcs: string): boolean {
  return useJog(kulcs) > 0;
}

/** Vehet-e fel újat (a meglévőt nem feltétlenül írhatja át). */
export function useUjFelvetel(kulcs: string): boolean {
  return useJog(kulcs) > 1;
}

/** Átírhatja-e a meglévő adatokat. */
export function useModosithat(kulcs: string): boolean {
  return useJog(kulcs) > 2;
}

/** Törölni csak adminisztrátor tud — erre nincs külön kapcsoló. */
export function useTorolhet(): boolean {
  return !!useFelhasznalo()?.admin;
}

/** Külön engedélyhez kötött művelet (például nap lezárása). */
export function useMuvelet(kulcs: string): boolean {
  const f = useFelhasznalo();
  return !!f && (f.admin || (f.jogok[kulcs] ?? 0) > 0);
}
